import React from "react";
import styles from "./Accentbar.module.scss";

interface AccentBarProps {
    isActive?: boolean;
}

const AccentBar: React.FC<AccentBarProps> = ({ isActive = false }) => {
    return (
        <div
            className={`${styles.AccentBar} ${isActive ? styles.AccentBarActive : ""}`}>
        </div>
    );
};

export default AccentBar;
